<!--
 * @Author: congcongpang pangcongcong@bovaesg.com
 * @Date: 2023-10-10 09:36:36
 * @LastEditors: congcongpang pangcongcong@bovaesg.com
 * @LastEditTime: 2023-10-26 17:17:28
 * @FilePath: \official-website\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <Header></Header>
    <div class="container-bg">
      <router-view />
    </div>
    <Footer></Footer>
    <!-- <GoTop></GoTop> -->
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
body {
  height: 100%;
}
#app {
  height: 100%;
  position: relative;
}
#app .container-bg {
  /* background: url('./assets/img/banner1.png') no-repeat;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: auto; */
  /* height: calc(100% - 200px); */
  height: calc(100% - 90px);
  /* padding-bottom: 200px; */
  background-color: #f6f5fa;
}

</style>



// WEBPACK FOOTER //
// src/App.vue